export const drawToCanvas = ({size, draw}) => {
    const c = document.createElement("canvas");
    c.width  = size.width;
    c.height = size.height;
    draw(c);

    return c;
};
